<form class="dynamic-form" [formGroup]="form" *ngIf="fieldsLoaded()" autocomplete="off" >
    <ng-container *ngFor="let field of fields; let i = index">
        <div class="row mt-1" *ngIf="isNewRow(i+1)">
            <div [class]="getColClass()" *ngFor="let subField of subFields;">
                <ng-container dynamicField [field]="subField" [group]="form" [formName]="name"></ng-container>
            </div>
        </div>
    </ng-container>
</form>
